import {Name} from './name.js';

export var Names = function(namesData) {
    var names = {};
    
    // Constructor
    if (namesData) {
        if (namesData.default) {
            names.default = Name(namesData.default);
        }
        if (namesData.local) {
            names.local = Name(namesData.local);
        }
        if (namesData.nonLocal) {
            names.nonLocal = Name(namesData.nonLocal);
        }
        if (namesData.local2) {
            names.local2 = Name(namesData.local2);
        }
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    names.getAName = function() {
        var name;

        if (names.default) {
            name = names.default;
        } else if (names.local) {
            name = names.local;
        } else if (names.local2) {
            name = names.local2;
        } else if (names.nonLocal) {
            name = names.nonLocal;
        }

        return name;
    };
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return names;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/names.js
// module id = 34
// module chunks = 0